var React = require('react');
var PropTypes = React.PropTypes;
var moment = require('moment');

var ReviewCommentList = React.createClass({

  getInitialState: function() {
    return {
      comments: this.props.comments
    };
  },

  componentWillMount: function() {

  },

  componentWillReceiveProps: function(nextProps) {
    if (nextProps.comments) {
      this.setState({
        comments: nextProps.comments
      })
    }
  },

  render: function() {
    var _this = this;
    return (
      <div className="comment-container">
        {
        _this.state.comments.map(function(comment, index) {
          if (comment.type==='TASK_MESSAGE' || comment.type==='KQUESTION_MESSAGE' || comment.reviewScore>0) {
            return (
              <div className="comment" key={index}>
                <div className="comment-title">
                  <div className="main">{comment.reviewerName || comment.creatorName || 'Anonymous'}</div>
                  <div className="sub">{moment(comment.dateModified).format('DD MMM, YYYY - hh:mm A')}</div>
                </div>
                <div className="comment-content">
                  { (comment.type === "TASK_MESSAGE" || comment.type === 'KQUESTION_MESSAGE') &&
                    <p>{comment.text}</p>
                  }
                  {
                    (comment.type === "COLLECTION_KQUESTIONS_REVIEW" || comment.type === "COLLECTION_KQUESTIONS_ADMIN_REVIEW") && comment.reviewScore === 1 && <p className="approve">Approve this question</p>
                  }
                  {
                    (comment.type === "COLLECTION_KQUESTIONS_REVIEW" || comment.type === "COLLECTION_KQUESTIONS_ADMIN_REVIEW") && comment.reviewScore === 2 && <p className="need-review">Need review</p>
                  }
                </div>
              </div>
            )
          }
        })
        }
      </div>
    );
  },

  componentDidMount: function() {

  }

});

export default ReviewCommentList;



/** WEBPACK FOOTER **
 ** ./src/components/Tasks/Review/ReviewCommentList.js
 **/